import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation32({ animation, badge, all_animations }: Props) {
  const [stamped, setStamped] = useState(false)
  const [showInk, setShowInk] = useState(false)

  useEffect(() => {
    setTimeout(() => setStamped(true), 500)
    setTimeout(() => setShowInk(true), 600)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes stampDown {
          0% {
            transform: translateY(-200px) scale(1.5);
            opacity: 0.8;
          }
          70% {
            transform: translateY(10px) scale(0.95);
          }
          85% {
            transform: translateY(-5px) scale(1.02);
          }
          100% {
            transform: translateY(0) scale(1);
            opacity: 1;
          }
        }
        @keyframes inkSpread {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            transform: scale(2);
            opacity: 0;
          }
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
        .stamp-down {
          animation: stampDown 0.5s cubic-bezier(0.36, 0, 0.66, -0.56) forwards;
        }
        .ink-spread {
          animation: inkSpread 0.8s ease-out forwards;
        }
        .shake {
          animation: shake 0.1s ease-in-out 3;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Zone de tampon */}
        <div className={`relative ${stamped ? 'shake' : ''}`}>
          {/* Effet d'encre qui se répand */}
          {showInk && (
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-32 h-32 sm:w-44 sm:h-44 rounded-full bg-tessan-yellow/30 ink-spread" />
            </div>
          )}

          {/* Badge tampon */}
          <div className={`relative ${stamped ? 'stamp-down' : 'opacity-0 -translate-y-48'}`}>
            <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 border-4 border-tessan-yellow">
              <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
            </div>

            {/* Marque "VALIDÉ" */}
            <div className={`absolute -bottom-2 -right-2 bg-tessan-yellow text-tessan-green px-3 py-1 rounded-full font-bold text-sm transform rotate-12 transition-opacity duration-300 ${stamped ? 'opacity-100' : 'opacity-0'}`}>
              VALIDÉ ✓
            </div>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 delay-500 ${stamped ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
